import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", id: "services" },
  { label: "Works",    id: "works"    },
  { label: "Blog",     id: "blog"     },
  { label: "Contact",  id: "contact"  },
];

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const Navigation = () => {
  const [isOpen,   setIsOpen]   = useState(false);
  const [active,   setActive]   = useState("");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    scrollTo(id);
    setIsOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0d0e18]/95 backdrop-blur-sm shadow-lg shadow-black/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between h-16">
        {/* Logo */}
        <button
          onClick={() => { setActive(""); scrollTo("home"); }}
          className="font-IBM font-bold text-xl text-white"
        >
          <span className="text-[#f5c210]">S</span>tefan.
        </button>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-10">
          {links.map(({ label, id }) => (
            <li key={id}>
              <button
                onClick={() => handleClick(id)}
                className="relative font-IBM text-sm tracking-wide pb-1 group"
              >
                <span className={active === id ? "text-white" : "text-gray-400 group-hover:text-white transition-colors"}>
                  {label}
                </span>
                <span
                  className={`absolute bottom-0 left-0 h-[2px] bg-[#f5c210] transition-all duration-300 ${
                    active === id ? "w-full" : "w-0 group-hover:w-full"
                  }`}
                />
              </button>
            </li>
          ))}
          <li>
            <a
              href="/Stefan Latić CV.pdf"
              download
              className="font-IBM text-sm text-[#0d0e18] bg-[#f5c210] px-4 py-1.5 rounded hover:bg-yellow-300 transition-colors"
            >
              Resume
            </a>
          </li>
        </ul>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-[#131523] border-t border-[#1e2030] px-6 py-4 flex flex-col gap-1">
          {links.map(({ label, id }) => (
            <button
              key={id}
              onClick={() => handleClick(id)}
              className="text-left font-IBM text-gray-300 hover:text-white py-3 border-b border-[#1e2030] text-sm tracking-wide"
            >
              {label}
            </button>
          ))}
          <a
            href="/Stefan Latić CV.pdf"
            download
            className="mt-3 text-center font-IBM text-sm text-[#0d0e18] bg-[#f5c210] px-4 py-2 rounded"
          >
            Download Resume
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
